var items = {
  "block.minecraft.air": "ajër",
  "block.minecraft.stone": "gur",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit i lëmuar",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "lëmuar diorite",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "lëmuar andesite",
  "block.minecraft.grass_block": "bllok bari",
  "block.minecraft.dirt": "dhe",
  "block.minecraft.coarse_dirt": "të trashë pluhuri",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "nilium i kuqërremtë",
  "block.minecraft.warped_nylium": "nilium i deformuar",
  "block.minecraft.cobblestone": "kalldrëm",
  "block.minecraft.oak_planks": "pllaka lisi",
  "block.minecraft.spruce_planks": "dërrasa bredhi",
  "block.minecraft.birch_planks": "dërrasa mështekëne",
  "block.minecraft.jungle_planks": "dërrasa xhungle",
  "block.minecraft.acacia_planks": "dërrasa akacie",
  "block.minecraft.dark_oak_planks": "dërrasa ahu te zi",
  "block.minecraft.crimson_planks": "dërrasë të kuqërremta",
  "block.minecraft.warped_planks": "dërrasë të deformuara",
  "block.minecraft.oak_sapling": "fidan ahu",
  "block.minecraft.spruce_sapling": "fidan bredhi",
  "block.minecraft.birch_sapling": "fidan mështekëne",
  "block.minecraft.jungle_sapling": "fidan xhungle",
  "block.minecraft.acacia_sapling": "fidan akacie",
  "block.minecraft.dark_oak_sapling": "fidan ahu të zi",
  "block.minecraft.bedrock": "bazë-gur",
  "block.minecraft.sand": "rërë",
  "block.minecraft.red_sand": "rërë e kuqe",
  "block.minecraft.gravel": "zall",
  "block.minecraft.gold_ore": "xehe ari",
  "block.minecraft.iron_ore": "xehe hekuri",
  "block.minecraft.coal_ore": "xehe qymyri",
  "block.minecraft.nether_gold_ore": "mineral ari i nether-it",
  "block.minecraft.oak_log": "trung dushku",
  "block.minecraft.spruce_log": "trung bredhi",
  "block.minecraft.birch_log": "trung mështekre",
  "block.minecraft.jungle_log": "trung xhungle",
  "block.minecraft.acacia_log": "trung acacie",
  "block.minecraft.dark_oak_log": "trung i dushkut të errët",
  "block.minecraft.crimson_stem": "kërcell i kuqërremtë",
  "block.minecraft.warped_stem": "kërcell i deformuar",
  "block.minecraft.stripped_oak_log": "trung dushku i zhveshur",
  "block.minecraft.stripped_spruce_log": "trung bredhi i zhveshur",
  "block.minecraft.stripped_birch_log": "trung mështekre i zhveshur",
  "block.minecraft.stripped_jungle_log": "trung xhungle i zhveshur",
  "block.minecraft.stripped_acacia_log": "trung akacie i zhveshur",
  "block.minecraft.stripped_dark_oak_log": "trung i dushkut të errët i zhveshur",
  "block.minecraft.stripped_crimson_stem": "kërcell i kuqërremtë pa lëvore",
  "block.minecraft.stripped_warped_stem": "kërcell i deformuar pa lëvore",
  "block.minecraft.stripped_oak_wood": "dru dushku i zhveshur",
  "block.minecraft.stripped_spruce_wood": "dru bredhi i zhveshur",
  "block.minecraft.stripped_birch_wood": "dru mështekre i zhveshur",
  "block.minecraft.stripped_jungle_wood": "dru xhungle i zhveshur",
  "block.minecraft.stripped_acacia_wood": "dru i zhveshur i akacies",
  "block.minecraft.stripped_dark_oak_wood": "dru i dushkut të errët i zhveshur",
  "block.minecraft.stripped_crimson_hyphae": "hife të kuqërremta pa lëvore",
  "block.minecraft.stripped_warped_hyphae": "hife të deformuara pa lëvore",
  "block.minecraft.oak_wood": "dru dushku",
  "block.minecraft.spruce_wood": "dru bredhi",
  "block.minecraft.birch_wood": "dru mështekre",
  "block.minecraft.jungle_wood": "dru xhungle",
  "block.minecraft.acacia_wood": "dru akacie",
  "block.minecraft.dark_oak_wood": "dru i dushkut të ërret",
  "block.minecraft.crimson_hyphae": "hife të kuqërremta",
  "block.minecraft.warped_hyphae": "hife të deformuara",
  "block.minecraft.oak_leaves": "gjethe dushku",
  "block.minecraft.spruce_leaves": "gjethe bredhi",
  "block.minecraft.birch_leaves": "gjethe mështekre",
  "block.minecraft.jungle_leaves": "gjethe xhungle",
  "block.minecraft.acacia_leaves": "gjethe akacie",
  "block.minecraft.dark_oak_leaves": "gjethe të dushkut të errët",
  "block.minecraft.sponge": "sfungjer",
  "block.minecraft.wet_sponge": "sfungjer i lagur",
  "block.minecraft.glass": "qelq",
  "block.minecraft.lapis_ore": "lapis lazuli xeheror",
  "block.minecraft.lapis_block": "lapis lazuli bllok",
  "block.minecraft.dispenser": "gjuajtës",
  "block.minecraft.sandstone": "gur rëre",
  "block.minecraft.chiseled_sandstone": "gur rëre i gdhendur",
  "block.minecraft.cut_sandstone": "prej gur ranor",
  "block.minecraft.note_block": "shënim blloku",
  "block.minecraft.powered_rail": "shina elektrike",
  "block.minecraft.detector_rail": "detektor hekurudhor",
  "block.minecraft.sticky_piston": "ngjitës piston",
  "block.minecraft.cobweb": "grackë",
  "block.minecraft.grass": "bar",
  "block.minecraft.fern": "fier",
  "block.minecraft.dead_bush": "shkurrë e vdekur",
  "block.minecraft.seagrass": "bar deti",
  "block.minecraft.sea_pickle": "turshi deti",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "lesh i bardhe",
  "block.minecraft.orange_wool": "lesh portokalli",
  "block.minecraft.magenta_wool": "lesh magenta",
  "block.minecraft.light_blue_wool": "i çelët leshi blu",
  "block.minecraft.yellow_wool": "leshi i verdhë",
  "block.minecraft.lime_wool": "leshi i gëlqeres",
  "block.minecraft.pink_wool": "leshi trëndafili",
  "block.minecraft.gray_wool": "leshi gri",
  "block.minecraft.light_gray_wool": "leshi gri e lehte",
  "block.minecraft.cyan_wool": "leshi cian",
  "block.minecraft.purple_wool": "leshi purpur",
  "block.minecraft.blue_wool": "leshi blu",
  "block.minecraft.brown_wool": "lesh kafe",
  "block.minecraft.green_wool": "lesh i gjelbër",
  "block.minecraft.red_wool": "lesh i kuqë",
  "block.minecraft.black_wool": "lesh i zi",
  "block.minecraft.dandelion": "luleradhiqe",
  "block.minecraft.poppy": "lulekuqe",
  "block.minecraft.blue_orchid": "orkide e kaltërt",
  "block.minecraft.allium": "alium",
  "block.minecraft.azure_bluet": "kokoçel i kaltërt",
  "block.minecraft.red_tulip": "tulipan i kuq",
  "block.minecraft.orange_tulip": "tulipan portokalli",
  "block.minecraft.white_tulip": "tulipan i bardhë",
  "block.minecraft.pink_tulip": "tulipan rozë",
  "block.minecraft.oxeye_daisy": "luleshqerrë",
  "block.minecraft.cornflower": "kokoçeli ngjyrë qielli",
  "block.minecraft.lily_of_the_valley": "zambakut të luginës",
  "block.minecraft.wither_rose": "trëndafil i wither-it",
  "block.minecraft.brown_mushroom": "kerpurdhë bojëkafe",
  "block.minecraft.red_mushroom": "kërpudhë e kuqe",
  "block.minecraft.crimson_fungus": "kërpurdhë e kuqërremtë",
  "block.minecraft.warped_fungus": "kërpudh e deformuar",
  "block.minecraft.crimson_roots": "rrënjë të kuqërremta",
  "block.minecraft.warped_roots": "rrënjë të deformuara",
  "block.minecraft.nether_sprouts": "bari nether-it",
  "block.minecraft.weeping_vines": "hardhi qarëse",
  "block.minecraft.twisting_vines": "hardhi të përdredhura",
  "block.minecraft.sugar_cane": "kallam sheqeri",
  "block.minecraft.kelp": "leshterik",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "bllok i arit",
  "block.minecraft.iron_block": "bllok i hekurit",
  "block.minecraft.oak_slab": "gjysëm lisi",
  "block.minecraft.spruce_slab": "gjysëm lisi",
  "block.minecraft.birch_slab": "gjysëm lisi",
  "block.minecraft.jungle_slab": "gjysëm lisi",
  "block.minecraft.acacia_slab": "gjysëm lisi",
  "block.minecraft.dark_oak_slab": "gjysëm lisi",
  "block.minecraft.crimson_slab": "pllakë të kuqërremtë",
  "block.minecraft.warped_slab": "pllakë e deformuar",
  "block.minecraft.stone_slab": "pllakë e gurit",
  "block.minecraft.smooth_stone_slab": "pllakë guri e lëmuar",
  "block.minecraft.sandstone_slab": "pllakë e gurit të rërës",
  "block.minecraft.cut_sandstone_slab": "pritini gur ranor",
  "block.minecraft.petrified_oak_slab": "petrified lisi pllakë",
  "block.minecraft.cobblestone_slab": "pllakë kalldrumi",
  "block.minecraft.brick_slab": "gjysëm tullë",
  "block.minecraft.stone_brick_slab": "gjysëm tullë guri",
  "block.minecraft.nether_brick_slab": "pllakë tullash e nether-it",
  "block.minecraft.quartz_slab": "pllakë kuarci",
  "block.minecraft.red_sandstone_slab": "pllakë e gurit të rërës së kuqe",
  "block.minecraft.cut_red_sandstone_slab": "pritini gur ranor të kuq",
  "block.minecraft.purpur_slab": "vjollcë pllakë",
  "block.minecraft.prismarine_slab": "gjysëm prismarine",
  "block.minecraft.prismarine_brick_slab": "gjysëm prismarine guri",
  "block.minecraft.dark_prismarine_slab": "gjysëm lisi",
  "block.minecraft.smooth_quartz": "bllok kuarci të lëmuar",
  "block.minecraft.smooth_red_sandstone": "gur rëre e kuqe e lëmuar",
  "block.minecraft.smooth_sandstone": "gur rëre e lëmuar",
  "block.minecraft.smooth_stone": "gurë i lëmuar",
  "block.minecraft.bricks": "tulla",
  "block.minecraft.tnt": "dinamit",
  "block.minecraft.bookshelf": "raft librash",
  "block.minecraft.mossy_cobblestone": "gurë i myshkur",
  "block.minecraft.obsidian": "xham vullkanik",
  "block.minecraft.torch": "pishtar",
  "block.minecraft.end_rod": "shkop endi",
  "block.minecraft.chorus_plant": "bimë korus",
  "block.minecraft.chorus_flower": "lule korus",
  "block.minecraft.purpur_block": "bllok vjollcë",
  "block.minecraft.purpur_pillar": "shtyllë vjollcë",
  "block.minecraft.purpur_stairs": "shkallët vjollcës",
  "block.minecraft.spawner": "ngjallës",
  "block.minecraft.oak_stairs": "shkallë druri",
  "block.minecraft.chest": "sënduk",
  "block.minecraft.diamond_ore": "diamant",
  "block.minecraft.diamond_block": "bllok djamanti",
  "block.minecraft.crafting_table": "tabela e artizanatit",
  "block.minecraft.farmland": "toka bujqësore",
  "block.minecraft.furnace": "stofë",
  "block.minecraft.ladder": "shkallë",
  "block.minecraft.rail": "shina",
  "block.minecraft.cobblestone_stairs": "shkallë me kalldrëm",
  "block.minecraft.lever": "levë",
  "block.minecraft.stone_pressure_plate": "pllakë e presionit të gurit",
  "block.minecraft.oak_pressure_plate": "oak pllakë presioni",
  "block.minecraft.spruce_pressure_plate": "spruce pllakë presioni",
  "block.minecraft.birch_pressure_plate": "brich pllakë presioni",
  "block.minecraft.jungle_pressure_plate": "jungle pllakë presioni",
  "block.minecraft.acacia_pressure_plate": "acacia pllakë presioni",
  "block.minecraft.dark_oak_pressure_plate": "dark oak pllakë presioni",
  "block.minecraft.crimson_pressure_plate": "pllakë presioni e kuqërremtë",
  "block.minecraft.warped_pressure_plate": "pllakë presionit e deformuar",
  "block.minecraft.polished_blackstone_pressure_plate": "pllakë presionit të gurit të zi",
  "block.minecraft.redstone_ore": "redstone xeheror",
  "block.minecraft.redstone_torch": "pishtar i kuq",
  "block.minecraft.snow": "borë",
  "block.minecraft.ice": "akull",
  "block.minecraft.snow_block": "bllok dëbore",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "argjilë",
  "block.minecraft.jukebox": "gramafon",
  "block.minecraft.oak_fence": "gardh me dru lisi",
  "block.minecraft.spruce_fence": "gardh me dru bredhi",
  "block.minecraft.birch_fence": "gardh me dru të bardhë",
  "block.minecraft.jungle_fence": "gardh me dru xhungle",
  "block.minecraft.acacia_fence": "gardh me dru akacie",
  "block.minecraft.dark_oak_fence": "gardh me dru të errët",
  "block.minecraft.crimson_fence": "gardh i kuqërremtë",
  "block.minecraft.warped_fence": "gardh i deformuar",
  "block.minecraft.pumpkin": "kungull",
  "block.minecraft.carved_pumpkin": "kungull i gdhendur",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "rërë shpirti",
  "block.minecraft.soul_soil": "tokë e shpirtrave",
  "block.minecraft.basalt": "bazalti",
  "block.minecraft.polished_basalt": "bazalti i lëmuar",
  "block.minecraft.soul_torch": "pishtar i shpirtrave",
  "block.minecraft.glowstone": "gur ndriçues",
  "block.minecraft.jack_o_lantern": "kungull i ndriçuar",
  "block.minecraft.oak_trapdoor": "trungu i lisi",
  "block.minecraft.spruce_trapdoor": "barku i bredhit",
  "block.minecraft.birch_trapdoor": "betoni i thupërve",
  "block.minecraft.jungle_trapdoor": "trapdoor që jeton në xhungël",
  "block.minecraft.acacia_trapdoor": "trapdoor për akaci",
  "block.minecraft.dark_oak_trapdoor": "errësirë të errët të lisi",
  "block.minecraft.crimson_trapdoor": "derë kurthi e kuqërremtë",
  "block.minecraft.warped_trapdoor": "derë kurthi e deformuar",
  "block.minecraft.infested_stone": "gur i infektuar",
  "block.minecraft.infested_cobblestone": "kalldrëm i infektuar",
  "block.minecraft.infested_stone_bricks": "tulla të infektuara me gurë",
  "block.minecraft.infested_mossy_stone_bricks": "tulla të mbushura me myk",
  "block.minecraft.infested_cracked_stone_bricks": "tulla të gërmuara të infektuara",
  "block.minecraft.infested_chiseled_stone_bricks": "tulla të gërmuara të këputura",
  "block.minecraft.stone_bricks": "tulla të gurit",
  "block.minecraft.mossy_stone_bricks": "me myshk tulla të gurit",
  "block.minecraft.cracked_stone_bricks": "i plasaritur tulla të gurit",
  "block.minecraft.chiseled_stone_bricks": "tulla guri të gdhendura",
  "block.minecraft.brown_mushroom_block": "bllok i kerpurdhës bojëkafe",
  "block.minecraft.red_mushroom_block": "bllok i kerpurdhës kuqe",
  "block.minecraft.mushroom_stem": "rrënjë kerpurdhash",
  "block.minecraft.iron_bars": "bar hekuri",
  "block.minecraft.chain": "zinxhir",
  "block.minecraft.glass_pane": "xham",
  "block.minecraft.melon": "pjepër",
  "block.minecraft.vine": "hardhi",
  "block.minecraft.oak_fence_gate": "portë me dru lisi",
  "block.minecraft.spruce_fence_gate": "portë me dru bredhi",
  "block.minecraft.birch_fence_gate": "portë me dru të bardhë",
  "block.minecraft.jungle_fence_gate": "portë me dru xhungle",
  "block.minecraft.acacia_fence_gate": "portë me dru akacie",
  "block.minecraft.dark_oak_fence_gate": "portë me dru të errët",
  "block.minecraft.crimson_fence_gate": "derë gardhi e kuqërremtë",
  "block.minecraft.warped_fence_gate": "derë gardhi e deformuar",
  "block.minecraft.brick_stairs": "shkallë tulle",
  "block.minecraft.stone_brick_stairs": "shkallë tulle guri",
  "block.minecraft.mycelium": "miceli",
  "block.minecraft.lily_pad": "zambak uji",
  "block.minecraft.nether_bricks": "tulla e nether-it",
  "block.minecraft.cracked_nether_bricks": "tulla nether-it të thyera",
  "block.minecraft.chiseled_nether_bricks": "tulla nether-it të gdhendura",
  "block.minecraft.nether_brick_fence": "gardh tullash e nether-it",
  "block.minecraft.nether_brick_stairs": "shkallë tullash e nether-it",
  "block.minecraft.enchanting_table": "tavolinë magjie",
  "block.minecraft.end_portal_frame": "kornizë portali endit",
  "block.minecraft.end_stone": "gur endi",
  "block.minecraft.end_stone_bricks": "mbaroni tulla prej guri",
  "block.minecraft.dragon_egg": "vezë dragoi",
  "block.minecraft.redstone_lamp": "llambë redstone",
  "block.minecraft.sandstone_stairs": "shkallët ranore",
  "block.minecraft.emerald_ore": "mineral smeraldi",
  "block.minecraft.ender_chest": "arkë enderi",
  "block.minecraft.tripwire_hook": "mbajtëse penje",
  "block.minecraft.emerald_block": "bllok smeraldi",
  "block.minecraft.spruce_stairs": "shkallë druri",
  "block.minecraft.birch_stairs": "shkallë druri",
  "block.minecraft.jungle_stairs": "shkallë druri",
  "block.minecraft.crimson_stairs": "shkallët të kuqërremta",
  "block.minecraft.warped_stairs": "shkallët e deformuara",
  "block.minecraft.command_block": "blloku i komandave",
  "block.minecraft.beacon": "fener",
  "block.minecraft.cobblestone_wall": "me kalldrëm mur",
  "block.minecraft.mossy_cobblestone_wall": "mur kalldrëmi me myshk",
  "block.minecraft.brick_wall": "mur tulle",
  "block.minecraft.prismarine_wall": "mur prizmarine",
  "block.minecraft.red_sandstone_wall": "mur guri të rërës së kuqe",
  "block.minecraft.mossy_stone_brick_wall": "mur guri myshkur",
  "block.minecraft.granite_wall": "mur graniti",
  "block.minecraft.stone_brick_wall": "mur guri tullë",
  "block.minecraft.nether_brick_wall": "muri me tulla e nether-it",
  "block.minecraft.andesite_wall": "mur andeziti",
  "block.minecraft.red_nether_brick_wall": "muri me tulla të kuqe e nether-it",
  "block.minecraft.sandstone_wall": "murr guri rëre",
  "block.minecraft.end_stone_brick_wall": "mur guri i tullës së endit",
  "block.minecraft.diorite_wall": "mur dioriti",
  "block.minecraft.blackstone_wall": "gurizi mur",
  "block.minecraft.polished_blackstone_wall": "muri i gurit të zi",
  "block.minecraft.polished_blackstone_brick_wall": "muri i lemuar të shkëmbit të zi",
  "block.minecraft.stone_button": "buton guri",
  "block.minecraft.oak_button": "buton druri",
  "block.minecraft.spruce_button": "spurce buton",
  "block.minecraft.birch_button": "brich buton",
  "block.minecraft.jungle_button": "jungle buton",
  "block.minecraft.acacia_button": "acacia buton",
  "block.minecraft.dark_oak_button": "dark oak buton",
  "block.minecraft.crimson_button": "buton i kuqërremtë",
  "block.minecraft.warped_button": "buton i deformuar",
  "block.minecraft.polished_blackstone_button": "buton i gurit të zi",
  "block.minecraft.anvil": "kudhër",
  "block.minecraft.chipped_anvil": "çeliku i shkrirë",
  "block.minecraft.damaged_anvil": "anvil i dëmtuar",
  "block.minecraft.trapped_chest": "bllokuar sënduk",
  "block.minecraft.light_weighted_pressure_plate": "pesh e lhetë pllakë presioni",
  "block.minecraft.heavy_weighted_pressure_plate": "pesh e rende pllakë presioni",
  "block.minecraft.daylight_detector": "detektor i ditës",
  "block.minecraft.redstone_block": "bllok redstoneje",
  "block.minecraft.nether_quartz_ore": "mineral kuarci i nether-it",
  "block.minecraft.hopper": "hoper",
  "block.minecraft.chiseled_quartz_block": "gdhend kuarcit blloku",
  "block.minecraft.quartz_block": "kuarcit blloku",
  "block.minecraft.quartz_bricks": "tulla kuarcit",
  "block.minecraft.quartz_pillar": "shtylla kuarc",
  "block.minecraft.quartz_stairs": "kuarcit shkallë",
  "block.minecraft.activator_rail": "aktivizues hekurudhor",
  "block.minecraft.dropper": "hedhës",
  "block.minecraft.white_terracotta": "terrakota të bardhë",
  "block.minecraft.orange_terracotta": "terrakotë portokalli",
  "block.minecraft.magenta_terracotta": "terrakotë e purpurtë",
  "block.minecraft.light_blue_terracotta": "terrakotë bojëqielli",
  "block.minecraft.yellow_terracotta": "terrakotë e verdhë",
  "block.minecraft.lime_terracotta": "terrakotë jeshile e lehtë",
  "block.minecraft.pink_terracotta": "terrakotë rozë",
  "block.minecraft.gray_terracotta": "terrakotë e hirtë",
  "block.minecraft.light_gray_terracotta": "terrakotë e hirtë e lehtë",
  "block.minecraft.cyan_terracotta": "terrakotë cijan",
  "block.minecraft.purple_terracotta": "terracottë vjollcë",
  "block.minecraft.blue_terracotta": "terrakotë e kaltërt",
  "block.minecraft.brown_terracotta": "terrakotë bojëkafe",
  "block.minecraft.green_terracotta": "terrakotë jeshile",
  "block.minecraft.red_terracotta": "kuqe terrakote",
  "block.minecraft.black_terracotta": "terrakotë e zezë",
  "block.minecraft.barrier": "barjerë",
  "block.minecraft.iron_trapdoor": "dera e kurthit të hekurit",
  "block.minecraft.hay_block": "tufë gruri",
  "block.minecraft.white_carpet": "qilim të bardhë",
  "block.minecraft.orange_carpet": "qilim portokalli",
  "block.minecraft.magenta_carpet": "qilim magenta",
  "block.minecraft.light_blue_carpet": "qilim të lehta blu",
  "block.minecraft.yellow_carpet": "qilim të verdhë",
  "block.minecraft.lime_carpet": "qilim të gëlqeres",
  "block.minecraft.pink_carpet": "qilim rozë",
  "block.minecraft.gray_carpet": "qilim gri",
  "block.minecraft.light_gray_carpet": "qilim gri të lehta",
  "block.minecraft.cyan_carpet": "qilim cian",
  "block.minecraft.purple_carpet": "qilim purpur",
  "block.minecraft.blue_carpet": "qilim blu",
  "block.minecraft.brown_carpet": "qilim ngjyrë kafe",
  "block.minecraft.green_carpet": "qilim jeshil",
  "block.minecraft.red_carpet": "qilim i kuq",
  "block.minecraft.black_carpet": "qilim i zi",
  "block.minecraft.terracotta": "terrakotë",
  "block.minecraft.coal_block": "bllok i qymyrit",
  "block.minecraft.packed_ice": "akull i mbushur",
  "block.minecraft.acacia_stairs": "shkallë druri",
  "block.minecraft.dark_oak_stairs": "shkallë druri",
  "block.minecraft.slime_block": "llucë blloku",
  "block.minecraft.grass_path": "rrugë bari",
  "block.minecraft.sunflower": "luledielli",
  "block.minecraft.lilac": "jargavan",
  "block.minecraft.rose_bush": "shkurre trëndafili",
  "block.minecraft.peony": "bozhure",
  "block.minecraft.tall_grass": "bar i gjatë",
  "block.minecraft.large_fern": "fier i gjerë",
  "block.minecraft.white_stained_glass": "qelq i bardhë",
  "block.minecraft.orange_stained_glass": "qelq portokalli",
  "block.minecraft.magenta_stained_glass": "qele i purpurtë",
  "block.minecraft.light_blue_stained_glass": "qelq bojëqielli",
  "block.minecraft.yellow_stained_glass": "qelq i verdhë",
  "block.minecraft.lime_stained_glass": "qelq jeshil i lehtë",
  "block.minecraft.pink_stained_glass": "qelq rozë",
  "block.minecraft.gray_stained_glass": "qelq i hirtë",
  "block.minecraft.light_gray_stained_glass": "qelq i hirtë e lehtë",
  "block.minecraft.cyan_stained_glass": "qelq cijan",
  "block.minecraft.purple_stained_glass": "qelq vjollcë",
  "block.minecraft.blue_stained_glass": "qelq i kaltërt",
  "block.minecraft.brown_stained_glass": "qelq bojëkafe",
  "block.minecraft.green_stained_glass": "qelq jeshil",
  "block.minecraft.red_stained_glass": "qelq i kuq",
  "block.minecraft.black_stained_glass": "qelq i zi",
  "block.minecraft.white_stained_glass_pane": "xham i bardhë",
  "block.minecraft.orange_stained_glass_pane": "xham portokalli",
  "block.minecraft.magenta_stained_glass_pane": "xham i purpurtë",
  "block.minecraft.light_blue_stained_glass_pane": "xham bojëqielli",
  "block.minecraft.yellow_stained_glass_pane": "xham i verdhë",
  "block.minecraft.lime_stained_glass_pane": "xham jeshil i lehtë",
  "block.minecraft.pink_stained_glass_pane": "xham rozë",
  "block.minecraft.gray_stained_glass_pane": "xham i hirtë",
  "block.minecraft.light_gray_stained_glass_pane": "xham i hirtë i lehtë",
  "block.minecraft.cyan_stained_glass_pane": "xham cijani",
  "block.minecraft.purple_stained_glass_pane": "xham vjollcë",
  "block.minecraft.blue_stained_glass_pane": "xham i kaltërt",
  "block.minecraft.brown_stained_glass_pane": "xham bojëkafe",
  "block.minecraft.green_stained_glass_pane": "xham jeshil",
  "block.minecraft.red_stained_glass_pane": "xham i kuq",
  "block.minecraft.black_stained_glass_pane": "xham i zi",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "tulla prismarine",
  "block.minecraft.dark_prismarine": "prismarine errët",
  "block.minecraft.prismarine_stairs": "prismarine shkallë",
  "block.minecraft.prismarine_brick_stairs": "prismarine tullë shkallë",
  "block.minecraft.dark_prismarine_stairs": "prismarine te erret shkallë",
  "block.minecraft.sea_lantern": "det fanar",
  "block.minecraft.red_sandstone": "gur rëre e kuqe",
  "block.minecraft.chiseled_red_sandstone": "gur rëre e kuqe e gdhendur",
  "block.minecraft.cut_red_sandstone": "pritini gur ranor të kuq",
  "block.minecraft.red_sandstone_stairs": "shkallët e rrëkimit të kuq",
  "block.minecraft.repeating_command_block": "blloku i komadave qe përsëritet",
  "block.minecraft.chain_command_block": "blloku i komandave që vazhdohen",
  "block.minecraft.magma_block": "bllok magme",
  "block.minecraft.nether_wart_block": "blloku i lythave e nether-it",
  "block.minecraft.warped_wart_block": "bllok i lythave të deformuara",
  "block.minecraft.red_nether_bricks": "tulla të kuqe e nether-it",
  "block.minecraft.bone_block": "bllok kocke",
  "block.minecraft.structure_void": "strukturë boshe",
  "block.minecraft.observer": "obzervues",
  "block.minecraft.shulker_box": "kutia kudhër",
  "block.minecraft.white_shulker_box": "kutia bardhë skuller",
  "block.minecraft.orange_shulker_box": "kutia portokall skuller",
  "block.minecraft.magenta_shulker_box": "kutia purpurtë skuller",
  "block.minecraft.light_blue_shulker_box": "kutia blu të lehta skuller",
  "block.minecraft.yellow_shulker_box": "kutia verdhe skuller",
  "block.minecraft.lime_shulker_box": "kutia bli skuller",
  "block.minecraft.pink_shulker_box": "kutia lule skuller",
  "block.minecraft.gray_shulker_box": "kutia gri skuller",
  "block.minecraft.light_gray_shulker_box": "kutia gri të lehta skuller",
  "block.minecraft.cyan_shulker_box": "kutia cyan skuller",
  "block.minecraft.purple_shulker_box": "kutia vjollcë skuller",
  "block.minecraft.blue_shulker_box": "kutia  kudhër blu",
  "block.minecraft.brown_shulker_box": "kutia  kudhër kafe",
  "block.minecraft.green_shulker_box": "kutia gri kudhër",
  "block.minecraft.red_shulker_box": "kutia cyan kudhër",
  "block.minecraft.black_shulker_box": "kutia  kudhër e zeze",
  "block.minecraft.white_glazed_terracotta": "blanc glaze ttc",
  "block.minecraft.orange_glazed_terracotta": "portokalli terrakote",
  "block.minecraft.magenta_glazed_terracotta": "xham terrakote magjenta",
  "block.minecraft.light_blue_glazed_terracotta": "xham terrakote i kaltër e qeltë",
  "block.minecraft.yellow_glazed_terracotta": "xham terrakote e verdhë",
  "block.minecraft.lime_glazed_terracotta": "xham terrakote bliri",
  "block.minecraft.pink_glazed_terracotta": "xham terrakote rozë",
  "block.minecraft.gray_glazed_terracotta": "blanc glaze ttc",
  "block.minecraft.light_gray_glazed_terracotta": "blanc me xham ttc",
  "block.minecraft.cyan_glazed_terracotta": "blanc glaze ttc",
  "block.minecraft.purple_glazed_terracotta": "portokalli me xham terrakote",
  "block.minecraft.blue_glazed_terracotta": "xham terrakote e kaltër",
  "block.minecraft.brown_glazed_terracotta": "xham terrakote kafe",
  "block.minecraft.green_glazed_terracotta": "xham terrakotee gjelbër",
  "block.minecraft.red_glazed_terracotta": "xham terrakote e kuqe",
  "block.minecraft.black_glazed_terracotta": "xham terrakote e zezë",
  "block.minecraft.white_concrete": "beton i bardhë",
  "block.minecraft.orange_concrete": "beton portokall",
  "block.minecraft.magenta_concrete": "konkret magjente",
  "block.minecraft.light_blue_concrete": "beton blu i celur",
  "block.minecraft.yellow_concrete": "beton i verdhë",
  "block.minecraft.lime_concrete": "beton jeshile e celur",
  "block.minecraft.pink_concrete": "beton rozë",
  "block.minecraft.gray_concrete": "beton gri",
  "block.minecraft.light_gray_concrete": "beton i gri e çelur",
  "block.minecraft.cyan_concrete": "beton gurkali",
  "block.minecraft.purple_concrete": "beton lejla",
  "block.minecraft.blue_concrete": "beton i blu",
  "block.minecraft.brown_concrete": "beton kafe",
  "block.minecraft.green_concrete": "beton jeshil",
  "block.minecraft.red_concrete": "beton i kuq",
  "block.minecraft.black_concrete": "beton i zi",
  "block.minecraft.white_concrete_powder": "pluhur konkreti i bardhë",
  "block.minecraft.orange_concrete_powder": "pluhur konkreti portokalli",
  "block.minecraft.magenta_concrete_powder": "pluhur konkreti magjente",
  "block.minecraft.light_blue_concrete_powder": "pluhur konkreti i kaltër i qeltë",
  "block.minecraft.yellow_concrete_powder": "pluhur konkreti e verdhë",
  "block.minecraft.lime_concrete_powder": "pluhur konkreti i blirit",
  "block.minecraft.pink_concrete_powder": "pluhur konkreti rozë",
  "block.minecraft.gray_concrete_powder": "pluhur konkreti e hirtë",
  "block.minecraft.light_gray_concrete_powder": "pluhur konkreti e hirtë e qeltë",
  "block.minecraft.cyan_concrete_powder": "pluhur konkreti qielli",
  "block.minecraft.purple_concrete_powder": "pluhur konkreti vjollcë",
  "block.minecraft.blue_concrete_powder": "pluhur konkreti i kaltër",
  "block.minecraft.brown_concrete_powder": "pluhur konkreti kafe",
  "block.minecraft.green_concrete_powder": "pluhur konkreti i gjelbër",
  "block.minecraft.red_concrete_powder": "pluhur konkreti i kuq",
  "block.minecraft.black_concrete_powder": "pluhur konkreti i zi",
  "block.minecraft.turtle_egg": "vezë breshkë",
  "block.minecraft.dead_tube_coral_block": "blloku i koraleve të dead tube",
  "block.minecraft.dead_brain_coral_block": "blloku i vdekur brain coral",
  "block.minecraft.dead_bubble_coral_block": "blloku i dead bubble coral",
  "block.minecraft.dead_fire_coral_block": "blloku i dead fire coral",
  "block.minecraft.dead_horn_coral_block": "blloku i dead horn coral",
  "block.minecraft.tube_coral_block": "blloku i dead tube coral",
  "block.minecraft.brain_coral_block": "blloku i brain coral",
  "block.minecraft.bubble_coral_block": "blloku i bubble coral",
  "block.minecraft.fire_coral_block": "blloku i fire coral",
  "block.minecraft.horn_coral_block": "blloku i horn coral",
  "block.minecraft.tube_coral": "tube coral",
  "block.minecraft.brain_coral": "brain coral",
  "block.minecraft.bubble_coral": "bubble coral",
  "block.minecraft.fire_coral": "fire coral",
  "block.minecraft.horn_coral": "horn coral",
  "block.minecraft.dead_brain_coral": "dead brain coral",
  "block.minecraft.dead_bubble_coral": "dead bubble coral",
  "block.minecraft.dead_fire_coral": "dead fire coral",
  "block.minecraft.dead_horn_coral": "dead horn coral",
  "block.minecraft.dead_tube_coral": "dead tube coral",
  "block.minecraft.tube_coral_fan": "fan tube coral",
  "block.minecraft.brain_coral_fan": "fan brain coral",
  "block.minecraft.bubble_coral_fan": "fan bubble coral",
  "block.minecraft.fire_coral_fan": "fan fire coral",
  "block.minecraft.horn_coral_fan": "fan horn coral",
  "block.minecraft.dead_tube_coral_fan": "fan dead tube coral",
  "block.minecraft.dead_brain_coral_fan": "fan dead brain coral",
  "block.minecraft.dead_bubble_coral_fan": "fan dead bubble coral",
  "block.minecraft.dead_fire_coral_fan": "fan dead fire coral",
  "block.minecraft.dead_horn_coral_fan": "fan dead horn coral",
  "block.minecraft.blue_ice": "akull i kaltërt",
  "block.minecraft.conduit": "conduit",
  "block.minecraft.polished_granite_stairs": "shkallët e lëmuar prej granitit",
  "block.minecraft.smooth_red_sandstone_stairs": "shkallët e lëmuara prej rërës së kuqe",
  "block.minecraft.mossy_stone_brick_stairs": "shkallët me tulla guri me myshqe",
  "block.minecraft.polished_diorite_stairs": "shkallët e lëmuar prej dioritit",
  "block.minecraft.mossy_cobblestone_stairs": "shkallët e kalldrëmit me myshqe",
  "block.minecraft.end_stone_brick_stairs": "shkallët me tulla guri prej endit",
  "block.minecraft.stone_stairs": "shkallët guri",
  "block.minecraft.smooth_sandstone_stairs": "shkallët e lëmuara prej rërës",
  "block.minecraft.smooth_quartz_stairs": "shkallët e lëmuara prej kuarcit",
  "block.minecraft.granite_stairs": "shkallët graniti",
  "block.minecraft.andesite_stairs": "shkallët andesiti",
  "block.minecraft.red_nether_brick_stairs": "shkallët me tulla të kuqe prej nether-it",
  "block.minecraft.polished_andesite_stairs": "shkallët e lëmuar prej andesitit",
  "block.minecraft.diorite_stairs": "shkallët dioriti",
  "block.minecraft.polished_granite_slab": "pllak e granitit të shtypur",
  "block.minecraft.smooth_red_sandstone_slab": "pllak e lëmuar e gurit rënor të kuq",
  "block.minecraft.mossy_stone_brick_slab": "pllaka e tullave mossy stone",
  "block.minecraft.polished_diorite_slab": "pllakë diorite e lëmuar",
  "block.minecraft.mossy_cobblestone_slab": "pllakë kalldrëmi mossy",
  "block.minecraft.end_stone_brick_slab": "pllaka e tullave fundore",
  "block.minecraft.smooth_sandstone_slab": "pllakë e butë ranor",
  "block.minecraft.smooth_quartz_slab": "pllakë e butë kuarci",
  "block.minecraft.granite_slab": "pllakë graniti",
  "block.minecraft.andesite_slab": "pllakë andesite",
  "block.minecraft.red_nether_brick_slab": "pllakë tullash të kuqe e nether-it",
  "block.minecraft.polished_andesite_slab": "pllakë andesite e lëmuar",
  "block.minecraft.diorite_slab": "pjatë dioriti",
  "block.minecraft.scaffolding": "skeleri",
  "block.minecraft.iron_door": "dere hekuri",
  "block.minecraft.oak_door": "derë ahu",
  "block.minecraft.spruce_door": "derë bredhi",
  "block.minecraft.birch_door": "derë mështekëne",
  "block.minecraft.jungle_door": "derë xhungle",
  "block.minecraft.acacia_door": "derë akacie",
  "block.minecraft.dark_oak_door": "derë ahu të zi",
  "block.minecraft.crimson_door": "derë e kuqërremtë",
  "block.minecraft.warped_door": "derë e deformuar",
  "block.minecraft.repeater": "përsëritës redstoni",
  "block.minecraft.comparator": "krahasues redstoni",
  "block.minecraft.structure_block": "bllok strukture",
  "block.minecraft.jigsaw": "puzzle-bllok",
  "item.minecraft.turtle_helmet": "guaskë breshke□□kur në kokë:□+2 mbrojtje",
  "item.minecraft.scute": "stendë",
  "item.minecraft.iron_shovel": "lopatë hekuri□□kur në dorën kryesore:□+3.5 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.iron_pickaxe": "kazmë hekuri□□kur në dorën kryesore:□+3 dëm sulmi□-2.8 shpejtesi sulmi",
  "item.minecraft.iron_axe": "sëpatë hekuri□□kur në dorën kryesore:□+8 dëm sulmi□-3.1 shpejtesi sulmi",
  "item.minecraft.flint_and_steel": "strall dhe hekur",
  "item.minecraft.apple": "mollë",
  "item.minecraft.bow": "hark",
  "item.minecraft.arrow": "shigjetë",
  "item.minecraft.coal": "qymyrgur",
  "item.minecraft.charcoal": "qymyr",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "shufër hekuri",
  "item.minecraft.gold_ingot": "shufër ari",
  "item.minecraft.netherite_ingot": "shufër netheriti",
  "item.minecraft.netherite_scrap": "fragment netheriti",
  "item.minecraft.iron_sword": "shpatë hekuri□□kur në dorën kryesore:□+5 dëm sulmi□-2.4 shpejtesi sulmi",
  "item.minecraft.wooden_sword": "shpatë druri□□kur në dorën kryesore:□+3 dëm sulmi□-2.4 shpejtesi sulmi",
  "item.minecraft.wooden_shovel": "lopatë druri□□kur në dorën kryesore:□+1.5 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.wooden_pickaxe": "kazmë druri□□kur në dorën kryesore:□+1 dëm sulmi□-2.8 shpejtesi sulmi",
  "item.minecraft.wooden_axe": "sëpatë druri□□kur në dorën kryesore:□+6 dëm sulmi□-3.2 shpejtesi sulmi",
  "item.minecraft.stone_sword": "shpatë guri□□kur në dorën kryesore:□+4 dëm sulmi□-2.4 shpejtesi sulmi",
  "item.minecraft.stone_shovel": "lopatë guri□□kur në dorën kryesore:□+2.5 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.stone_pickaxe": "kazmë druri□□kur në dorën kryesore:□+2 dëm sulmi□-2.8 shpejtesi sulmi",
  "item.minecraft.stone_axe": "sëpatë guri□□kur në dorën kryesore:□+8 dëm sulmi□-3.2 shpejtesi sulmi",
  "item.minecraft.diamond_sword": "shpatë diamanti□□kur në dorën kryesore:□+6 dëm sulmi□-2.4 shpejtesi sulmi",
  "item.minecraft.diamond_shovel": "lopatë diamanti□□kur në dorën kryesore:□+4.5 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.diamond_pickaxe": "kazmë diamanti□□kur në dorën kryesore:□+4 dëm sulmi□-2.8 shpejtesi sulmi",
  "item.minecraft.diamond_axe": "sëpatë diamanti□□kur në dorën kryesore:□+8 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.stick": "shkop",
  "item.minecraft.bowl": "tas",
  "item.minecraft.mushroom_stew": "supë kerpudhe",
  "item.minecraft.golden_sword": "shpatë e artë□□kur në dorën kryesore:□+3 dëm sulmi□-2.4 shpejtesi sulmi",
  "item.minecraft.golden_shovel": "lopatë ari□□kur në dorën kryesore:□+1.5 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.golden_pickaxe": "kazmë ari□□kur në dorën kryesore:□+1 dëm sulmi□-2.8 shpejtesi sulmi",
  "item.minecraft.golden_axe": "axe e artë□□kur në dorën kryesore:□+6 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.netherite_sword": "shpatë netheriti□□kur në dorën kryesore:□+7 dëm sulmi□-2.4 shpejtesi sulmi",
  "item.minecraft.netherite_shovel": "lopatë netheriti□□kur në dorën kryesore:□+5.5 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.netherite_pickaxe": "kazmë netheriti□□kur në dorën kryesore:□+5 dëm sulmi□-2.8 shpejtesi sulmi",
  "item.minecraft.netherite_axe": "sëpatë netheriti□□kur në dorën kryesore:□+9 dëm sulmi□-3 shpejtesi sulmi",
  "item.minecraft.string": "penjë",
  "item.minecraft.feather": "pendë",
  "item.minecraft.gunpowder": "barut",
  "item.minecraft.wooden_hoe": "kallam druri□□kur në dorën kryesore:□-3 shpejtesi sulmi",
  "item.minecraft.stone_hoe": "shat guri□□kur në dorën kryesore:□-2 shpejtesi sulmi",
  "item.minecraft.iron_hoe": "shat hekuri□□kur në dorën kryesore:□-1 shpejtesi sulmi",
  "item.minecraft.diamond_hoe": "shat diamanti□□kur në dorën kryesore:",
  "item.minecraft.golden_hoe": "shat e artë□□kur në dorën kryesore:□-3 shpejtesi sulmi",
  "item.minecraft.netherite_hoe": "kosë netheriti□□kur në dorën kryesore:",
  "item.minecraft.wheat_seeds": "fara gruri",
  "item.minecraft.wheat": "grurë",
  "item.minecraft.bread": "bukë",
  "item.minecraft.leather_helmet": "kapele lëkure□□kur në kokë:□+1 mbrojtje",
  "item.minecraft.leather_chestplate": "tunikë lëkure□□kur në trup:□+3 mbrojtje",
  "item.minecraft.leather_leggings": "pantallona lëkure□□kur tek kofshet:□+2 mbrojtje",
  "item.minecraft.leather_boots": "këpucë lëkure□□kur në këmbë:□+1 mbrojtje",
  "item.minecraft.chainmail_helmet": "helmetë zinxhiri□□kur në kokë:□+2 mbrojtje",
  "item.minecraft.chainmail_chestplate": "parzmore zinxhiri□□kur në trup:□+5 mbrojtje",
  "item.minecraft.chainmail_leggings": "dollakë zinxhiri□□kur tek kofshet:□+4 mbrojtje",
  "item.minecraft.chainmail_boots": "çizme zinxhiri□□kur në këmbë:□+1 mbrojtje",
  "item.minecraft.iron_helmet": "helmetë hekuri□□kur në kokë:□+2 mbrojtje",
  "item.minecraft.iron_chestplate": "parzmore hekuri□□kur në trup:□+6 mbrojtje",
  "item.minecraft.iron_leggings": "dollakë hekuri□□kur tek kofshet:□+5 mbrojtje",
  "item.minecraft.iron_boots": "çizme hekuri□□kur në këmbë:□+2 mbrojtje",
  "item.minecraft.diamond_helmet": "helmetë diamanti□□kur në kokë:□+3 mbrojtje□+2 fortësia e mbrojtjes",
  "item.minecraft.diamond_chestplate": "parzmore diamanti□□kur në trup:□+8 mbrojtje□+2 fortësia e mbrojtjes",
  "item.minecraft.diamond_leggings": "dollakë diamanti□□kur tek kofshet:□+6 mbrojtje□+2 fortësia e mbrojtjes",
  "item.minecraft.diamond_boots": "çizme diamanti□□kur në këmbë:□+3 mbrojtje□+2 fortësia e mbrojtjes",
  "item.minecraft.golden_helmet": "helmetë e artë□□kur në kokë:□+2 mbrojtje",
  "item.minecraft.golden_chestplate": "parzmore e artë□□kur në trup:□+5 mbrojtje",
  "item.minecraft.golden_leggings": "dollakë të artë□□kur tek kofshet:□+3 mbrojtje",
  "item.minecraft.golden_boots": "çizme të arta□□kur në këmbë:□+1 mbrojtje",
  "item.minecraft.netherite_helmet": "përkrenare netheriti□□kur në kokë:□+3 mbrojtje□+3 fortësia e mbrojtjes□+1 rezistencë knockback",
  "item.minecraft.netherite_chestplate": "parzmore netheriti□□kur në trup:□+8 mbrojtje□+3 fortësia e mbrojtjes□+1 rezistencë knockback",
  "item.minecraft.netherite_leggings": "dollakë netheriti□□kur tek kofshet:□+6 mbrojtje□+3 fortësia e mbrojtjes□+1 rezistencë knockback",
  "item.minecraft.netherite_boots": "çizme netheriti□□kur në këmbë:□+3 mbrojtje□+3 fortësia e mbrojtjes□+1 rezistencë knockback",
  "item.minecraft.flint": "strall",
  "item.minecraft.porkchop": "mish derri i pazierë",
  "item.minecraft.cooked_porkchop": "mish derri i zierrë",
  "item.minecraft.painting": "pikturë",
  "item.minecraft.golden_apple": "mollë e artë",
  "item.minecraft.enchanted_golden_apple": "mollë e artë e magjepsur",
  "block.minecraft.oak_sign": "shenjë lajmërimi prej drurit",
  "block.minecraft.spruce_sign": "shenjë lajmërimi prej drurit të bredhit",
  "block.minecraft.birch_sign": "shenjë lajmërimi prej drurit të thupëres",
  "block.minecraft.jungle_sign": "shenjë lajmërimi prej drurit të xhungles",
  "block.minecraft.acacia_sign": "shenjë lajmërimi prej drurit të akacies",
  "block.minecraft.dark_oak_sign": "shenjë lajmërimi prej drurit të zi",
  "block.minecraft.crimson_sign": "tabelë e kuqërremtë",
  "block.minecraft.warped_sign": "tabelë e deformuar",
  "item.minecraft.bucket": "kovë",
  "item.minecraft.water_bucket": "kovë me ujë",
  "item.minecraft.lava_bucket": "kovë me llavë",
  "item.minecraft.minecart": "karrocë",
  "item.minecraft.saddle": "shalë",
  "item.minecraft.redstone": "pluhur redstoni",
  "item.minecraft.snowball": "top bore",
  "item.minecraft.oak_boat": "anije lisi",
  "item.minecraft.leather": "lëkurë",
  "item.minecraft.milk_bucket": "kovë me qumësht",
  "item.minecraft.pufferfish_bucket": "kovë e pufferfish",
  "item.minecraft.salmon_bucket": "kovë me salmon",
  "item.minecraft.cod_bucket": "kovë me merluc",
  "item.minecraft.tropical_fish_bucket": "kovë me peshk tropikal",
  "item.minecraft.brick": "tullë",
  "item.minecraft.clay_ball": "copë argjile",
  "block.minecraft.dried_kelp_block": "bllok leshteriku i tharë",
  "item.minecraft.paper": "letër",
  "item.minecraft.book": "libër",
  "item.minecraft.slime_ball": "top zhuli",
  "item.minecraft.chest_minecart": "karrocë me arkë",
  "item.minecraft.furnace_minecart": "karrocë me stofë",
  "item.minecraft.egg": "vezë",
  "item.minecraft.compass": "busull",
  "item.minecraft.fishing_rod": "grep peshkimi",
  "item.minecraft.clock": "orë",
  "item.minecraft.glowstone_dust": "pluhur guri të ndritshëm",
  "item.minecraft.cod": "peshk i papërpunuar",
  "item.minecraft.salmon": "salmon i pazier",
  "item.minecraft.tropical_fish": "peshk tropikal",
  "item.minecraft.pufferfish": "peshk top",
  "item.minecraft.cooked_cod": "peshk i gatuar",
  "item.minecraft.cooked_salmon": "salmon i gatuar",
  "item.minecraft.ink_sac": "thes boje",
  "item.minecraft.red_dye": "ngjyra e kuqe",
  "item.minecraft.green_dye": "ngjyra e gjelbër",
  "item.minecraft.cocoa_beans": "fasule kakao",
  "item.minecraft.lapis_lazuli": "gur i kaltër",
  "item.minecraft.purple_dye": "bojë vjollcë",
  "item.minecraft.cyan_dye": "bojë qielli",
  "item.minecraft.light_gray_dye": "bojë hiri e qeltë",
  "item.minecraft.gray_dye": "bojë hiri",
  "item.minecraft.pink_dye": "bojë rozë",
  "item.minecraft.lime_dye": "bojë bliri",
  "item.minecraft.yellow_dye": "ngjyra e verdhë",
  "item.minecraft.light_blue_dye": "bojë e kaltër e qeltë",
  "item.minecraft.magenta_dye": "bojë magjente",
  "item.minecraft.orange_dye": "bojë portokalli",
  "item.minecraft.bone_meal": "kocka të shtypura",
  "item.minecraft.blue_dye": "ngjyra e kaltër",
  "item.minecraft.brown_dye": "ngjyra e kaftë",
  "item.minecraft.black_dye": "ngjyra e zezë",
  "item.minecraft.white_dye": "ngjyra e bardhë",
  "item.minecraft.bone": "kockë",
  "item.minecraft.sugar": "sheqer",
  "block.minecraft.cake": "tortë",
  "block.minecraft.white_bed": "shtrat i bardhë",
  "block.minecraft.orange_bed": "shtrat portokalli",
  "block.minecraft.magenta_bed": "shtrat magjente",
  "block.minecraft.light_blue_bed": "shtrat i kaltër i qeltë",
  "block.minecraft.yellow_bed": "shtrat i verdhë",
  "block.minecraft.lime_bed": "shtrat bliri",
  "block.minecraft.pink_bed": "shtrat rozë",
  "block.minecraft.gray_bed": "shtrat i hirtë",
  "block.minecraft.light_gray_bed": "shtrat i hirtë i qeltë",
  "block.minecraft.cyan_bed": "shtrat qielli",
  "block.minecraft.purple_bed": "shtrat vjollcë",
  "block.minecraft.blue_bed": "shtrat i kaltër",
  "block.minecraft.brown_bed": "shtrat kafe",
  "block.minecraft.green_bed": "shtrat i gjelbër",
  "block.minecraft.red_bed": "shtrat i kuq",
  "block.minecraft.black_bed": "shtrat i zi",
  "item.minecraft.cookie": "biskotë",
  "item.minecraft.filled_map": "hartë□#0",
  "item.minecraft.shears": "gërshërë",
  "item.minecraft.melon_slice": "copë pjepri",
  "item.minecraft.dried_kelp": "leshterik i thatë",
  "item.minecraft.pumpkin_seeds": "fara kungulli",
  "item.minecraft.melon_seeds": "fara pjepri",
  "item.minecraft.beef": "mish lope i pazier",
  "item.minecraft.cooked_beef": "biftek",
  "item.minecraft.chicken": "pulë e pazier",
  "item.minecraft.cooked_chicken": "pulë e zierrë",
  "item.minecraft.rotten_flesh": "mish i kalbur",
  "item.minecraft.ender_pearl": "perlë ender",
  "item.minecraft.blaze_rod": "shkop i blaze-it",
  "item.minecraft.ghast_tear": "lot fantazme",
  "item.minecraft.gold_nugget": "copëz ari",
  "item.minecraft.nether_wart": "lythat e nether-it",
  "item.minecraft.potion": "ilaç i pamundshëm□pa efekt",
  "item.minecraft.glass_bottle": "shishe xhami",
  "item.minecraft.spider_eye": "sy merimange",
  "item.minecraft.fermented_spider_eye": "sy merimange i thartuar",
  "item.minecraft.blaze_powder": "pluhur flake",
  "item.minecraft.magma_cream": "krem magme",
  "block.minecraft.brewing_stand": "banak ilaçesh",
  "block.minecraft.cauldron": "kazan",
  "item.minecraft.ender_eye": "sy enderi",
  "item.minecraft.glistering_melon_slice": "pjepër i ndritshëm",
  "item.minecraft.bat_spawn_egg": "vezë lakuriq nate",
  "item.minecraft.bee_spawn_egg": "vezë thirrëse bletësh",
  "item.minecraft.blaze_spawn_egg": "vezë flake",
  "item.minecraft.cat_spawn_egg": "vezë macesh",
  "item.minecraft.cave_spider_spawn_egg": "vezë merimange shpelle",
  "item.minecraft.chicken_spawn_egg": "chicken spawn veza",
  "item.minecraft.cod_spawn_egg": "cod spawn veza",
  "item.minecraft.cow_spawn_egg": "cow spawn veza",
  "item.minecraft.creeper_spawn_egg": "creeper spawn veza",
  "item.minecraft.dolphin_spawn_egg": "dolphin spawn veza",
  "item.minecraft.donkey_spawn_egg": "donkey spawn veza",
  "item.minecraft.drowned_spawn_egg": "drowned spawn veza",
  "item.minecraft.elder_guardian_spawn_egg": "kujdestari plaku spawn veza",
  "item.minecraft.enderman_spawn_egg": "enderman spawn veza",
  "item.minecraft.endermite_spawn_egg": "endermite spawn veza",
  "item.minecraft.evoker_spawn_egg": "evokojeni vezë të vezëve",
  "item.minecraft.fox_spawn_egg": "vezë pjellore e dhelprave",
  "item.minecraft.ghast_spawn_egg": "ghast spawn veza",
  "item.minecraft.guardian_spawn_egg": "guardian spawn veza",
  "item.minecraft.hoglin_spawn_egg": "vezë thirrëse hoglin-it",
  "item.minecraft.horse_spawn_egg": "kali i hedhur vezë",
  "item.minecraft.husk_spawn_egg": "husk spawn veza",
  "item.minecraft.llama_spawn_egg": "llama spawn veza",
  "item.minecraft.magma_cube_spawn_egg": "magma cube spawn veza",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom spawn veza",
  "item.minecraft.mule_spawn_egg": "mule spawn veza",
  "item.minecraft.ocelot_spawn_egg": "ocelot spawn veza",
  "item.minecraft.panda_spawn_egg": "panda spawn vezë",
  "item.minecraft.parrot_spawn_egg": "parrot spawn veza",
  "item.minecraft.phantom_spawn_egg": "phantom spawn veza",
  "item.minecraft.pig_spawn_egg": "pig spawn veza",
  "item.minecraft.piglin_spawn_egg": "vezë thirrëse piglin-it",
  "item.minecraft.pillager_spawn_egg": "vezë pjellore e shtizës",
  "item.minecraft.polar_bear_spawn_egg": "polar bear spawn veza",
  "item.minecraft.pufferfish_spawn_egg": "vezë pufferfish vezë",
  "item.minecraft.rabbit_spawn_egg": "lepuri derdh vezë",
  "item.minecraft.ravager_spawn_egg": "vezë pjellore ravager",
  "item.minecraft.salmon_spawn_egg": "salmon spawn veza",
  "item.minecraft.sheep_spawn_egg": "dele uji vezë",
  "item.minecraft.shulker_spawn_egg": "shulker spawn veza",
  "item.minecraft.silverfish_spawn_egg": "silverfish spawn veza",
  "item.minecraft.skeleton_spawn_egg": "skeleton spawn veza",
  "item.minecraft.skeleton_horse_spawn_egg": "skeleton horse spawn veza",
  "item.minecraft.slime_spawn_egg": "slime spawn veza",
  "item.minecraft.spider_spawn_egg": "spider spawn veza",
  "item.minecraft.squid_spawn_egg": "kallamar i hedh vezë",
  "item.minecraft.stray_spawn_egg": "stray spawn veza",
  "item.minecraft.strider_spawn_egg": "vezë thirrëse këmbësorit",
  "item.minecraft.trader_llama_spawn_egg": "tregtar llama spawn vezë",
  "item.minecraft.tropical_fish_spawn_egg": "peshku tropikale spawn veza",
  "item.minecraft.turtle_spawn_egg": "turtle spawn veza",
  "item.minecraft.vex_spawn_egg": "vex spawn veza",
  "item.minecraft.villager_spawn_egg": "villager spawn veza",
  "item.minecraft.vindicator_spawn_egg": "vindicator spawn veza",
  "item.minecraft.wandering_trader_spawn_egg": "tradhtar trupi vezë pjellor",
  "item.minecraft.witch_spawn_egg": "magjistare vezë",
  "item.minecraft.wither_skeleton_spawn_egg": "vaji i skeletit",
  "item.minecraft.wolf_spawn_egg": "volf uji spawn",
  "item.minecraft.zoglin_spawn_egg": "vezë thirrëse zoglin-it",
  "item.minecraft.zombie_spawn_egg": "zombie spawn veza",
  "item.minecraft.zombie_horse_spawn_egg": "kali i zjarrtë",
  "item.minecraft.zombie_villager_spawn_egg": "fshatar zombie pjellem vezë",
  "item.minecraft.zombified_piglin_spawn_egg": "vezë thirrëse piglin-it te zombifikuar",
  "item.minecraft.experience_bottle": "shishe magjike",
  "item.minecraft.fire_charge": "mbushje zjarri",
  "item.minecraft.writable_book": "libër dhe pupël",
  "item.minecraft.written_book": "libër i shkruar",
  "item.minecraft.emerald": "smerald",
  "item.minecraft.item_frame": "kornizë sendi",
  "block.minecraft.flower_pot": "vazo lulesh",
  "item.minecraft.carrot": "karotë",
  "item.minecraft.potato": "patate",
  "item.minecraft.baked_potato": "patate e pjekur",
  "item.minecraft.poisonous_potato": "patate helmuese",
  "item.minecraft.map": "hartë boshe",
  "item.minecraft.golden_carrot": "karotë e artë",
  "block.minecraft.skeleton_skull": "kafkë skeleti",
  "block.minecraft.wither_skeleton_skull": "kafkë skeleti wither",
  "block.minecraft.player_head": "kreu i lojtarit",
  "block.minecraft.zombie_head": "kokë zombie",
  "block.minecraft.creeper_head": "kokë creeperi",
  "block.minecraft.dragon_head": "kokë dragoi",
  "item.minecraft.carrot_on_a_stick": "karrot në shkop",
  "item.minecraft.warped_fungus_on_a_stick": "kërpudhe e deformuar në një shkop",
  "item.minecraft.nether_star": "yll i nether-it",
  "item.minecraft.pumpkin_pie": "pite kungulli",
  "item.minecraft.firework_rocket": "raket fishekzjarresh",
  "item.minecraft.firework_star": "yll fishekzjarresh",
  "item.minecraft.enchanted_book": "libër i magjepsur",
  "item.minecraft.nether_brick": "tullë e nether-it",
  "item.minecraft.quartz": "kuarc i nether-it",
  "item.minecraft.tnt_minecart": "karrocë me tnt",
  "item.minecraft.hopper_minecart": "karrocë me mbledhës",
  "item.minecraft.prismarine_shard": "copë prizmarine",
  "item.minecraft.prismarine_crystals": "kristale prizmarine",
  "item.minecraft.rabbit": "mish lepuri i pazier",
  "item.minecraft.cooked_rabbit": "mish lepuri i zier",
  "item.minecraft.rabbit_stew": "çomlek lepuri",
  "item.minecraft.rabbit_foot": "këmbë lepuri",
  "item.minecraft.rabbit_hide": "lëkurë lepuri",
  "item.minecraft.armor_stand": "mbajtëse parzmoresh",
  "item.minecraft.iron_horse_armor": "armaturë hekuri për kuaj",
  "item.minecraft.golden_horse_armor": "armaturë e artë për kuaj",
  "item.minecraft.diamond_horse_armor": "armaturë diamanti për kuaj",
  "item.minecraft.leather_horse_armor": "armaturë lëkure për kuaj",
  "item.minecraft.lead": "litar",
  "item.minecraft.name_tag": "etiketë",
  "item.minecraft.command_block_minecart": "karrocë me bllok komandave",
  "item.minecraft.mutton": "mish dele i pazierrë",
  "item.minecraft.cooked_mutton": "mish dele i zier",
  "block.minecraft.white_banner": "flamur i bardhë",
  "block.minecraft.orange_banner": "flamur i portokallet",
  "block.minecraft.magenta_banner": "flamur magenta",
  "block.minecraft.light_blue_banner": "flamur i kaltert i hapur",
  "block.minecraft.yellow_banner": "flamur i verdhe",
  "block.minecraft.lime_banner": "flamur i gjelbert i hapur",
  "block.minecraft.pink_banner": "flamur i pembet",
  "block.minecraft.gray_banner": "flamur i hiret",
  "block.minecraft.light_gray_banner": "flamur i hiret i hapur",
  "block.minecraft.cyan_banner": "flamur i cyan",
  "block.minecraft.purple_banner": "flamur i jargovant",
  "block.minecraft.blue_banner": "flamur i kaltert",
  "block.minecraft.brown_banner": "flamur i kafte",
  "block.minecraft.green_banner": "flamur i gjelbert",
  "block.minecraft.red_banner": "flamur i kuq",
  "block.minecraft.black_banner": "flamur i zi",
  "item.minecraft.end_crystal": "kristal endi",
  "item.minecraft.chorus_fruit": "frut korusi",
  "item.minecraft.popped_chorus_fruit": "frut korusi i pëlcitur",
  "item.minecraft.beetroot": "panxhar",
  "item.minecraft.beetroot_seeds": "fara panxhari",
  "item.minecraft.beetroot_soup": "supë panxhari",
  "item.minecraft.dragon_breath": "frymë dragoi",
  "item.minecraft.splash_potion": "ilaç i pamundshëm hedhëse□pa efekt",
  "item.minecraft.spectral_arrow": "shigjetë spektrale",
  "item.minecraft.tipped_arrow": "shigjetë me efekt i pamundshëm□pa efekt",
  "item.minecraft.lingering_potion": "pazhvilluara të potion□pa efekt",
  "item.minecraft.shield": "mburojë",
  "item.minecraft.elytra": "flatra",
  "item.minecraft.spruce_boat": "anije bredhi",
  "item.minecraft.birch_boat": "anije e bardhë",
  "item.minecraft.jungle_boat": "anije e xhunglës",
  "item.minecraft.acacia_boat": "anije akacie",
  "item.minecraft.dark_oak_boat": "anije me dru të zi",
  "item.minecraft.totem_of_undying": "totem i pavdekshmërisë",
  "item.minecraft.shulker_shell": "guaskë shulker",
  "item.minecraft.iron_nugget": "copëz hekuri",
  "item.minecraft.knowledge_book": "libër i ditjes",
  "item.minecraft.debug_stick": "shkop debug",
  "item.minecraft.music_disc_13": "disk muzike□c418 - 13",
  "item.minecraft.music_disc_cat": "disk muzike□c418 - mace",
  "item.minecraft.music_disc_blocks": "disk muzike□c418 - blloqe",
  "item.minecraft.music_disc_chirp": "disk muzike□c418 - cicërimë",
  "item.minecraft.music_disc_far": "disk muzike□c418 - larg",
  "item.minecraft.music_disc_mall": "disk muzike□c418 - dyqan",
  "item.minecraft.music_disc_mellohi": "disk muzike□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disk muzike□c418 - stal",
  "item.minecraft.music_disc_strad": "disk muzike□c418 - strad",
  "item.minecraft.music_disc_ward": "disk muzike□c418 - rojë",
  "item.minecraft.music_disc_11": "disk muzike□c418 - 11",
  "item.minecraft.music_disc_wait": "disk muzike□c418 - prit",
  "item.minecraft.music_disc_pigstep": "disk muzike□lena raine - pigstep",
  "item.minecraft.trident": "sfurk□□kur në dorën kryesore:□+8 dëm sulmi□-2.9 shpejtesi sulmi",
  "item.minecraft.phantom_membrane": "membranë e hijes",
  "item.minecraft.nautilus_shell": "guaskë kërmilli",
  "item.minecraft.heart_of_the_sea": "zemra e detit",
  "item.minecraft.crossbow": "hark",
  "item.minecraft.suspicious_stew": "stuh i dyshimtë",
  "block.minecraft.loom": "tezgjah",
  "item.minecraft.flower_banner_pattern": "model flamuri□kuq flower charge",
  "item.minecraft.creeper_banner_pattern": "model flamuri□kuq creeper charge",
  "item.minecraft.skull_banner_pattern": "model flamuri□kuq skull charge",
  "item.minecraft.mojang_banner_pattern": "model flamuri□gjë",
  "item.minecraft.globe_banner_pattern": "model flamuri□glob",
  "item.minecraft.piglin_banner_pattern": "model flamuri□feçkë",
  "block.minecraft.composter": "kazan për komposto",
  "block.minecraft.barrel": "fuçi",
  "block.minecraft.smoker": "bllok tymosje",
  "block.minecraft.blast_furnace": "furrë shpërthimi",
  "block.minecraft.cartography_table": "tavolinë hartografije",
  "block.minecraft.fletching_table": "tabela e fletëve",
  "block.minecraft.grindstone": "gurzmeril",
  "block.minecraft.lectern": "pupitër",
  "block.minecraft.smithing_table": "tabela e fletëve",
  "block.minecraft.stonecutter": "gurgdhendës",
  "block.minecraft.bell": "zile",
  "block.minecraft.lantern": "fanar",
  "block.minecraft.soul_lantern": "fanar i shpirtrave",
  "item.minecraft.sweet_berries": "manaferra të ëmbla",
  "block.minecraft.campfire": "zjarr kampi",
  "block.minecraft.soul_campfire": "zjarr kampi i shpirtrave",
  "block.minecraft.shroomlight": "kerpudhë e shndritshme",
  "item.minecraft.honeycomb": "huall mjalti",
  "block.minecraft.bee_nest": "fole bletësh",
  "block.minecraft.beehive": "koshere",
  "item.minecraft.honey_bottle": "shishe mjalti",
  "block.minecraft.honey_block": "bllok mjalti",
  "block.minecraft.honeycomb_block": "bllok hualli",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "bllok netheritit",
  "block.minecraft.ancient_debris": "mbetje antike",
  "block.minecraft.target": "shënjestër",
  "block.minecraft.crying_obsidian": "xham vullkanik që qanë",
  "block.minecraft.blackstone": "shkëmb i zi",
  "block.minecraft.blackstone_slab": "pllakë shkëmbi e zezë",
  "block.minecraft.blackstone_stairs": "shkallët e shkëmbit të zi",
  "block.minecraft.gilded_blackstone": "shkëmb i zi i artë",
  "block.minecraft.polished_blackstone": "gur i zi",
  "block.minecraft.polished_blackstone_slab": "pllakë guri e zezë",
  "block.minecraft.polished_blackstone_stairs": "shkallët e gurit të zi",
  "block.minecraft.chiseled_polished_blackstone": "rrip i shtypur i gurizi",
  "block.minecraft.polished_blackstone_bricks": "shkëmb i lemuar",
  "block.minecraft.polished_blackstone_brick_slab": "pllakë e lemuar të shkëmbit të zi",
  "block.minecraft.polished_blackstone_brick_stairs": "shkallët e lemuara të shkëmbit të zi",
  "block.minecraft.cracked_polished_blackstone_bricks": "shkëmb i lemuar i plasaritur i zi",
  "block.minecraft.respawn_anchor": "spiranca e ringjalljes",
}
export const sq_al = items; 
